import { useRef, useState, useEffect, useCallback } from 'react';

export function useSearchOnMenuOpen({ clearOnClose = true } = {}) {
  const searchInstanceRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const onMenuChange = useCallback(({ open }) => setIsOpen(open), []);

  useEffect(() => {
    const search = searchInstanceRef.current;
    if (!search) return;
    if (isOpen) search.clearSearch(true); // clear + focus on open
    else if (clearOnClose) search.clearSearch(false); // clear, no focus on close
  }, [isOpen, clearOnClose]);

  return { searchInstanceRef, onMenuChange };
}
